import { FC } from 'react';
import { Controller, Control, FieldValues } from 'react-hook-form';
import { TextFieldProps, Box, Chip } from '@mui/material';
import CheckboxAutocomplete from '@components/checkbox-autocomplete';
import { styles } from './styles';

type Props = {
  control: Control<FieldValues, any>;
  setVal: (newValue: string[]) => void;
  name: string;
  label: string;
  filterOptions: FilterOption[];
  disabled?: boolean;
  popupIcon?: JSX.Element;
  renderValueTitle?: boolean;
  selectedData: {
    state: string[];
  };
  selectTransform?: boolean;
};

const RHFCheckboxSelect: FC<Props & TextFieldProps> = ({
  name,
  label,
  filterOptions,
  control,
  setVal,
  disabled,
  renderValueTitle,
  popupIcon,
  selectedData,
  selectTransform,
}) => (
  <Box sx={styles.wrapper}>
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <CheckboxAutocomplete
          options={selectedData}
          filterOptions={filterOptions}
          handleSelect={setVal}
          renderValueTitle={renderValueTitle}
          componentProps={{
            disabled,
            disableClearable: true,
            size: 'small',
            limitTags: 51,
            sx: selectTransform ? styles.selectTransform : styles.select,
            popupIcon,
            style: { width: '100%' },
          }}
          inputProps={{ name: field.name, label }}
        />
      )}
    />

    {Array.isArray(selectedData?.state) && selectedData?.state?.length > 0 && !selectTransform && (
      <Box sx={styles.chipContainer}>
        {selectedData.state.map((option) => {
          const matchedOption = filterOptions.find((item) => item.value === option);
          const label = renderValueTitle ? option : matchedOption?.label || option;

          return (
            <Chip
              key={option}
              label={label}
              sx={styles.chip}
              onDelete={() => {
                const newSelected = selectedData.state.filter((item) => item !== option);
                setVal(newSelected);
              }}
            />
          );
        })}
      </Box>
    )}
  </Box>
);

export default RHFCheckboxSelect;
